import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Box,
  TextField,
  Grid,
  Divider,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputAdornment,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "../../Sass/Common.scss";
import { makeStyles } from "@mui/styles";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { ReactComponent as CalenderIcon } from "../../Assets/Icons/Calender.svg";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";
import { ReactComponent as CloseIcon } from "Assets/Icons/CloseIcon.svg";
import { useFormik } from "formik";
import { useXssGuard } from "Hooks/useXssGuard";
import * as yup from "yup";
import { connect } from "react-redux";
import { START_PATIENT_MULTI_ORDER } from "../../Actions/RepeatOrderAction";
import moment from "moment";
import dayjs from "dayjs";
import { START_GET_NO_OF_ALERT } from "../../Actions/HomeAction";
import { getLocalStorage } from "../../utils/generalUtils";
const useStyle = makeStyles((theme) => ({
  resConfirmationBox: {
    "&>div": {
      "&>div": {
        "&>h3": {
          marginTop: "30px !important",
        },
      },
      "&>div": {
        "&>h4": {
          marginTop: "25px",
        },
      },
    },
  },
  dialogActionBtn: {
    marginBottom: "20px",
  },
  textAlign: {
    textAlign: "center",
  },
  paper: {
    // minWidth: "500px",
    maxWidth: "530px !important",
    borderRadius: "15px !important",
  },
  Main: {
    justifyContent: "center",
    display: "block",
    "&>h3": {
      color: "black !important",
      justifyContent: "center",
      width: "100%",
      display: "flex",
      fontWeight: "600",
    },
    "&>h4": {
      color: "black !important",
      justifyContent: "center",
      fontSize: "18px !important",
      fontWeight: "500",
      width: "100%",
      display: "flex",
    },
    "&>h5": {
      color: "black !important",
      justifyContent: "center",
      fontSize: "1rem !important",
      fontWeight: "400",
      width: "100%",
      display: "flex",
      textAlign: "center",
      marginTop: "10px",
    },
  },
  rsClose: {
    right: "19px !important",
    top: "16px !important",
    position: "absolute !important",
    "&:hover": {
      background: "transparent !important",
      cursor: "pointer !important",
    },
  },
  rsGridOne: {
    width: "100%",
    justifyContent: "center",
    paddingTop: "20px",
    marginBottom: "50px",
    "&>div": {
      maxWidth: "244px",
    },
    "&>h3": {
      paddingTop: "20px",
      // paddingBottom: "10px",
      fontSize: "18px !important",
      fontWeight: "500 !important",
      color: "black !important",
    },
  },
  rsSubmit: {
    width: "100%",
    justifyContent: "center",
    display: "flex",
    "&>button": {
      width: "143px",
    },
    "&>button:first-child": {
      marginRight: "40px",
    },
  },
  assignmultiple: {
    maxWidth: "100%",
    display: "flex",
    listStyle: "none",
    flexWrap: "wrap",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    "&>p": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "fit-content",
    },
  },
  multipleList: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "center",
  },
  rsRepeatorder: {
    // display: "flex",
    justifyContent: "center",
  },
  TextBlackMultiple: {
    color: "#333 !important",
    fontSize: "16px !important",
    fontWeight: "400 !important",
    width: "70%",
    paddingRight: "2px",
    paddingLeft: "2px",
    whiteSpace: "nowrap",
  },
  rsDivider: {
    background: "rgba(80, 80, 80, 0.6) !important",
    marginTop: "10px !important",
  },
  radioGroup: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "10px",
    "&>label": {
      "&>span:nth-child(2)": {
        color: "black",
        fontSize: "1.125rem",
        [theme.breakpoints.down(366)]: {
          fontSize: "1rem",
        },
        [theme.breakpoints.down(340)]: {
          fontSize: "0.9rem",
        },
      },
    },
  },
  rsDateField: {
    "&>div": {
      paddingRight: "0px",
    },
  },
  rsDateFieldDisbale: {
    "&>div": {
      backgroundColor: "rgba(202, 202, 202, 0.6) !important",
      paddingRight: "0px",
    },
  },
  disableCalenderIcon: {
    "&>path": {
      fill: "rgba(80, 80, 80, 0.6)",
    },
  },
}));

const MultipleOrderDialog = (props) => {
  const classes = useStyle();
  const {
    open,
    setOpen,
    selected,
    loading = false,
    getPatientMultiOrderAction,
    patientMultiOrderData,
    setSelected,
    getNoOfAlertAction,
    getList = () => {},
  } = props;
  const [isOpenOrderDate, setIsOpenOrderDate] = React.useState(false);
  const [disableCalender, setDisableCalender] = React.useState(false);
  let temp = [];
  if (selected?.length > 0) {
    selected?.map((item) => {
      if (item?.order_count > 0) {
        temp?.push(item);
      }
    });
  }
  const DateType = [
    { item: "Different dates", type: "different_dates" },
    { item: "Same date", type: "same_date" },
  ];

  const defaultValues = {
    order_date: null,
    date_type: "same_date",
  };

  const [orderDate, setOrderDate] = useState(defaultValues);
  const selectedHeaderPharmacyId = getLocalStorage("Pharmacies", true);
  const handleUpdateDate = (formValues) => {
    let temppatient = [];
    selected?.map((item) => {
      temppatient.push(item?.id);
    });

    let payload = {
      patient_ids: temppatient,
      // weeks: "7",
      order_type: "quick",
    };
    if (formValues?.order_date) {
      payload.order_date = moment(new Date(formValues?.order_date)).format(
        "YYYY-MM-DD",
      );
    }
    getPatientMultiOrderAction(payload);
  };

  const { guardedSubmit: xssGuardedMultipleOrder } = useXssGuard(handleUpdateDate);


  /** Validation schema */
  const repeatOrderDateSchema = yup.object().shape({
    order_date: yup.string().nullable(),
    // .required("The order date field is required."),
  });
  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    touched,
    resetForm,
    setErrors,
    setFieldValue,
    handleBlur,

} = useFormik({
    initialValues: { ...defaultValues, ...orderDate },
    validationSchema: repeatOrderDateSchema,
    enableReinitialize: true,
    onSubmit: xssGuardedMultipleOrder,
  });

  const handleClose = () => {
    setOpen(false);
    setOrderDate(defaultValues);
    setDisableCalender(false);
    setIsOpenOrderDate(false);
    resetForm({ values: defaultValues });
  };

  useEffect(() => {
    if (
      !patientMultiOrderData?.loading &&
      patientMultiOrderData?.data?.success
    ) {
      handleClose();
      setSelected([]);
      let payLoad = {};
      getList();
      if (
        selectedHeaderPharmacyId !== "" &&
        selectedHeaderPharmacyId !== "all" &&
        selectedHeaderPharmacyId !== undefined &&
        selectedHeaderPharmacyId !== null
      ) {
        payLoad = {
          pharmacy_id: [selectedHeaderPharmacyId],
        };
        getNoOfAlertAction(payLoad);
      } else if (getLocalStorage("pharmacyChange") == "true") {
        getNoOfAlertAction(payLoad);
      } else {
        getNoOfAlertAction(payLoad);
      }
    }
  }, [patientMultiOrderData]);

  return (
    <>
      <Dialog
        classes={{ paper: classes.paper }}
        open={open}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
      >
        {/* <PrimaryIcon
          icon={CloseIcon}
          className={classes.rsClose}
          onClick={handleClose}
        /> */}
        <Grid className={classes.resConfirmationBox}>
          <DialogContent>
            <Grid className={classes.Main}>
              <Typography variant="h3">
                {selected?.length} Patients selected
              </Typography>
              <Divider className={classes.rsDivider} />
              <Typography variant="h5">
                Are these patients' repeat orders to be sent out on multiple
                different dates or all on the same date?
              </Typography>
              {/* {temp?.length > 0 && (
                <Typography variant="h4">
                  {" "}
                  A repeat order already exists for {temp?.length} patient!
                </Typography>
              )}
              {temp?.length !== 0 && temp?.length !== undefined && (
                <Box className={classes.rsRepeatorder}>
                  <Box className={classes.multipleList}>
                    <ul className={classes.assignmultiple}>
                      {`(`}
                      {temp?.map((item, index) => {
                        return (
                          <Typography
                            className={classes.TextBlackMultiple}
                            key={index}
                          >
                            {item?.name}
                            {index < temp.length - 1 ? "," : ""}
                          </Typography>
                        );
                      })}
                      {`)`}
                    </ul>
                  </Box>
                </Box>
              )} */}
              <RadioGroup
                aria-labelledby="date-type-radio-buttons-group-label"
                name="date-type-radio-buttons-group"
              >
                <Grid className={classes.radioGroup}>
                  {DateType?.map((item, index) => {
                    return (
                      <FormControlLabel
                        error={touched?.date_type && errors?.date_type}
                        helperText={touched?.date_type && errors?.date_type}
                        value={item.type}
                        key={index}
                        onChange={(e) => {
                          setFieldValue("date_type", item.type);
                          handleChange("date_type", item.type);
                          if (item.type === "same_date") {
                            setDisableCalender(false);
                          } else {
                            setDisableCalender(true);
                          }
                        }}
                        label={item.item}
                        control={
                          <Radio checked={values?.date_type === item.type} />
                        }
                      />
                    );
                  })}{" "}
                </Grid>
              </RadioGroup>
              <Grid container className={classes.rsGridOne}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      id="order_date"
                      name="order_date"
                      label="Repeat Order Date"
                      views={["year", "month", "day"]}
                      inputFormat="DD-MM-YYYY"
                      open={isOpenOrderDate}
                      onOpen={() => setIsOpenOrderDate(true)}
                      onClose={() => setIsOpenOrderDate(false)}
                      value={values?.order_date}
                      onChange={(newDate) => {
                        setFieldValue("order_date", newDate);
                      }}
                      disabled={disableCalender}
                      disableOpenPicker={disableCalender}
                      renderInput={(params) => (
                        <TextField
                          id="order_date"
                          onClick={() => {
                            if (disableCalender) {
                              setIsOpenOrderDate(false);
                            } else {
                              setIsOpenOrderDate(true);
                            }
                          }}
                          fullWidth
                          size="small"
                          name="order_date"
                          {...params}
                          error={touched?.order_date && errors?.order_date}
                          helperText={touched?.order_date && errors?.order_date}
                          onBlur={handleBlur}
                          className={
                            disableCalender
                              ? classes.rsDateFieldDisbale
                              : classes.rsDateField
                          }
                          disabled={disableCalender}
                          InputProps={{
                            endAdornment: (
                              <>
                                <InputAdornment position="start">
                                  <PrimaryIcon
                                    width="24px"
                                    icon={CalenderIcon}
                                    className={
                                      disableCalender
                                        ? classes.disableCalenderIcon
                                        : ""
                                    }
                                  />
                                </InputAdornment>
                              </>
                            ),
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
                {/* <Typography variant="h3">
                  Would you like to add these as repeat Orders?
                </Typography> */}
              </Grid>
            </Grid>
            <Box className={classes.rsSubmit}>
              <Button
                className="BtnGreen"
                variant="contained"
                disabled={patientMultiOrderData?.loading}
                startIcon={
                  patientMultiOrderData?.loading && (
                    <CircularProgress size="20px" color="white" />
                  )
                }
                onClick={() => {
                  handleSubmit();
                }}
              >
                Submit
              </Button>
              <Button
                className="BtnGray"
                variant="outlined"
                disabled={patientMultiOrderData?.loading}
                startIcon={
                  patientMultiOrderData?.loading && (
                    <CircularProgress size="20px" color="white" />
                  )
                }
                onClick={() => {
                  handleClose();
                }}
              >
                Cancel
              </Button>
            </Box>
          </DialogContent>
        </Grid>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => ({
  patientMultiOrderData: state.order.patientMultiOrderData,
});
const mapDispatchToProps = (dispatch) => ({
  getPatientMultiOrderAction: (payload) =>
    dispatch({ type: START_PATIENT_MULTI_ORDER, payload }),
  getNoOfAlertAction: (payload) =>
    dispatch({ type: START_GET_NO_OF_ALERT, payload }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MultipleOrderDialog);
